import React from 'react';
import { StyledInput } from '../StyledComponents';

const Textarea = ({ ...props }) => <StyledInput {...props} tag='textarea' />;

export default Textarea;
